export enum GalleryItemType {
  Product = 'PRODUCT',
  Image = 'IMAGE'
}

export enum GalleryMode {
  WithProducts = 'WithProducts',
  ImagesOnly = 'ImagesOnly'
}
